import { ComposibleValidatable, FieldState, FormState } from 'formstate'
import { makeObservable, observable } from 'mobx'
import {
  Allergen,
  DailyMenuDayCategoryTypeEnum,
} from '../../../../__generated__/graphql'
import { required } from '../../../utils/forms/validators'

export type StoreDailyMenuCategoryForm = ComposibleValidatable<{
  id: FieldState<string>
  title: FieldState<string>
  type: FieldState<DailyMenuDayCategoryTypeEnum>
  enabled: FieldState<boolean>
  order: FieldState<number>
  items: FormState<StoreDailyMenuCategoryItemForm[]>
}>

export type StoreDailyMenuCategoryItemForm = ComposibleValidatable<{
  id: FieldState<string>
  title: FieldState<string>
  portionSize: FieldState<string>
  price: FieldState<string>
  priceCombo: FieldState<string>
  order: FieldState<number>
  allergens: FieldState<Allergen['id'][]>
}>

export class StoreDailyMenuDayForm {
  date = new FieldState<string>('').validators(required)
  enabled = new FieldState<boolean>(true).validators()
  categories = new FormState(observable.array<StoreDailyMenuCategoryForm>([]))
}
export class StoreDailyMenuDaysForm {
  days = [] as StoreDailyMenuDayForm[]

  constructor() {
    makeObservable(this, {
      days: observable,
    })
  }

  serialize = async () => {
    return {
      days: this.days.map((day) => {
        return {
          date: day.date.value,
          enabled: day.enabled.$,
          categories: day.categories.$.map((category) => {
            return {
              title: category.$.title.$,
              type: category.$.type.$,
              order: category.$.order.$,
              enabled: category.$.enabled.$,
              items: category.$.items.$.map((item) => {
                return {
                  title: item.$.title.$,
                  portionSize: item.$.portionSize.$,
                  allergens: item.$.allergens.$,
                  price: item.$.price.$,
                  priceCombo: item.$.priceCombo.$,
                  order: item.$.order.$,
                }
              }),
            }
          }),
        }
      }),
    }
  }
}
